
<template>
  <div>
    <Header />
  </div>
</template>

<script>
import Header from "../shared/Drawer";
export default {
  components: {
    Header,
  },
  data() {
    return {
      overlay: true,
    };
  },
  mounted() {
    this.overlay = false;
    if (localStorage.user) {
      if (this.$route.path === "/") this.$router.push("/Home");
    } else this.$router.push("/Login");
  },
};
</script>

<style scoped>
</style>